import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import './dedicateflashcardmessage-style.css';
import * as React from "react";
import { AlertComponent } from "src/com/sixdee/crbtportal/ui/toolkit/alert/alertcomponent";
import { AlertType } from "src/com/sixdee/crbtportal/ui/toolkit/alert/alerttype";
import { LoaderComponent } from "src/com/sixdee/crbtportal/ui/toolkit/loader/loadercomponent";
import { UIDataModel, UIComponentHandler } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponent";
import { UIComponentViewImpl } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponentview";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { LoaderWrapperComponent } from "../../../../popup/loaderwrappercomponent";
import { PopUpWrapperComponent } from "../../../../popup/popupwrappercomponent";
import { DedicateFlashCardMessageComponentProps, DedicateFlashCardMessageComponentState, DedicateFlashCardMessageHandler } from "./dedicateflashcardmessagecomponent";
import { DedicateFlashCardMessageCSSStyle } from "./dedicateflashcardmessagecss";

export class DedicateFlashCardMessageViewImpl extends UIComponentViewImpl<UIDataModel> 
{  
    private loaderWrapperComponent:LoaderWrapperComponent;
    private popUpComponent: PopUpWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onDeleteDedicateClicked = this.onDeleteDedicateClicked.bind(this);
    }

    draw(props: DedicateFlashCardMessageComponentProps, state: DedicateFlashCardMessageComponentState, cssStyle: DedicateFlashCardMessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        return (
            <>      
            <div id="dedicate-flashmessage-main-wrapper1">
                {/* <div id="dedicate-flashmessage-div" >
                        <label id="dedicate-flashmessage-div-label" style={{}}>
                            {this.getContext().getResources().getString(Strings.dedicate_flash_message)}
                        </label>
                </div> */}
                <div id="dedicate-flashmessage-card-div" style={{backgroundImage: "url('" + this.getContext().getResources().getImage("flash_message_blue.svg") + "')"}}>
                    <div id="dedicate-flashmessage-card-img">
                        <img height="130px" width="48px" src={props.context.getResources().getImage("quotes.svg")}/>
                     </div>
                     <div id="dedicate-flashmessage-card-message-div">
                     <div>
                            <label id="dedicate-flashmessage-card-message-label1" style={{}}>
                                {state.flashDto.getNumber()}
                            </label>
                        </div>
                        <div id="dedicate-flashmessage-card-message-label2-div">
                            <label id="dedicate-flashmessage-card-message-label2" style={{}}>
                                {state.flashDto.getMessage()}
                            </label>
                        </div>
                       
                     </div>
                     
                     <div id="dedicate-flashmessage-card-delete-img" onClick={this.onDeleteDedicateClicked}>
                        <img height="28px" width="28px" src={props.context.getResources().getImage("delete.svg")}/>
                     </div>
                </div>
            </div> 
          
           </>  
        );
    }


    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    onDeleteDedicateClicked()
    {
        (this.getUIComponentHandler() as  DedicateFlashCardMessageHandler).onDeleteDedicateClicked();
    }
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
         
         this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicatecard/dedicateflashcardmessageview.tsx